export default "__VITE_ASSET__UHynqlZE__"